import React, { useState, useRef, useEffect } from 'react'

export interface OverflowAction {
  label: string
  onClick: () => void
  disabled?: boolean
  danger?: boolean
}

interface Props {
  actions: OverflowAction[]
}

export default function OverflowMenu({ actions }: Props) {
  const [open, setOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    function onClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => document.removeEventListener('mousedown', onClickOutside)
  }, [open])

  const visibleActions = actions.filter(a => !a.disabled)
  if (visibleActions.length === 0) return null

  return (
    <div className="overflow-menu" ref={menuRef}>
      <button
        className="overflow-trigger"
        onClick={e => { e.stopPropagation(); setOpen(v => !v) }}
        title="Actions"
      >
        ⋮
      </button>
      {open && (
        <div className="overflow-dropdown">
          {visibleActions.map((action, i) => (
            <button
              key={i}
              className={`overflow-item${action.danger ? ' overflow-item--danger' : ''}`}
              onClick={e => {
                e.stopPropagation()
                setOpen(false)
                action.onClick()
              }}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
